export default "__VITE_ASSET__CoZ8Gl_Z__"